/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetDocumentInput
 */
export interface WidgetDocumentInput {
    /**
     * 
     * @type {string}
     * @memberof WidgetDocumentInput
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetDocumentInput
     */
    mimeType?: string;
    /**
     * Base64-encoded file payload. Capped at ~6MB so that the worst case (3 documents) stays within the public widget endpoint body limit.
     * @type {string}
     * @memberof WidgetDocumentInput
     */
    fileContentBase64: string;
}

/**
 * Check if a given object implements the WidgetDocumentInput interface.
 */
export function instanceOfWidgetDocumentInput(value: object): value is WidgetDocumentInput {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('fileContentBase64' in value) || value['fileContentBase64'] === undefined) return false;
    return true;
}

export function WidgetDocumentInputFromJSON(json: any): WidgetDocumentInput {
    return WidgetDocumentInputFromJSONTyped(json, false);
}

export function WidgetDocumentInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDocumentInput {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'fileContentBase64': json['fileContentBase64'],
    };
}

export function WidgetDocumentInputToJSON(json: any): WidgetDocumentInput {
    return WidgetDocumentInputToJSONTyped(json, false);
}

export function WidgetDocumentInputToJSONTyped(value?: WidgetDocumentInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'fileContentBase64': value['fileContentBase64'],
    };
}

